import DashboardPage from '@/views/Dashboard/DashboardPage.vue'
import { AuthGuard } from '@/router/guards/AuthGuard.js'
import ResourcesPage from '@/views/Dashboard/ResourcesPage.vue'
import LearningCenterPage from '@/views/Dashboard/LearningCenterPage.vue'

export default [
	{
		path: '/dashboard',
		name: 'dashboard',
		component: DashboardPage,
		meta: {
			authGuard: AuthGuard.RequireLoggedIn,
			title: 'Home'
		}
	},
	{
		path: '/resources',
		name: 'resources',
		component: ResourcesPage,
		meta: {
			authGuard: AuthGuard.RequireLoggedIn,
			title: 'Resources'
		}
	},
	{
		path: '/learning-center',
		name: 'learning-center',
		component: LearningCenterPage,
		meta: {
			authGuard: AuthGuard.RequireLoggedIn,
			title: 'Learning Center'
		}
	}
]
